import React from 'react';

/**
 * Google sign-in button with the official "G" wordmark.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleLoginButton({ flow = 'login', testId = 'google-login-btn', className = '' }) {
  const handleClick = () => {
    // Derive redirect dynamically from current origin to keep auth working
    // across preview + production custom domain. DO NOT HARDCODE.
    const redirectUrl = `${window.location.origin}/auth/google-callback?flow=${flow}`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testId}
      className={`w-full h-11 flex items-center justify-center gap-2.5 border border-slate-200 rounded-xl bg-white text-sm font-semibold text-[#1A1A1A] hover:bg-slate-50 hover:border-slate-300 transition-colors ${className}`}
    >
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6.5 29.5 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.1l6.6 4.8C14.7 15.1 19 12.5 24 12.5c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6.5 29.5 4.5 24 4.5c-7.6 0-14.1 4.3-17.7 9.6z"/>
        <path fill="#4CAF50" d="M24 43.5c5.4 0 10.3-2.1 14-5.4l-6.5-5.3c-2 1.4-4.6 2.2-7.5 2.2-5.3 0-9.7-3.3-11.3-8l-6.6 5.1C9.7 38.9 16.3 43.5 24 43.5z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.1 4.1-3.8 5.5l6.5 5.3c-.5.4 7-5 7-14.3 0-1.2-.1-2.3-.4-3.5z"/>
      </svg>
      Continua con Google
    </button>
  );
}
